import { MenuProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppMenu } from "../../../../../../shared/components/AppMenu";
import { TMenuIds } from "../../../../../../app/state/menuSlice/types";
import { EditorValue } from "../../../../../../services/api/instances/editorApi/types";
import { StorageObjectVersion } from "../../../../../../services/api/instances/storageApi/types/object_types";
import { AppMenuItem } from "../../../../../../shared/components/AppMenu/AppMenuItem";
import { useMenuSelectors } from "../../../../../../app/state/menuSlice/hook/use-menu-selectors";
import styles from "./styles.module.css";

interface Props extends Omit<MenuProps, "open"> {
  versions: StorageObjectVersion<EditorValue>[];
  closeMenu: (id: TMenuIds) => void;
  handleChangePublishVersion: (
    version: StorageObjectVersion<EditorValue> | string,
  ) => void;
}

export const PublishVersionSelectorMenu = ({
  versions,
  closeMenu,
  handleChangePublishVersion,
}: Props) => {
  const publishVersion = useMenuSelectors("publish_version_menu");
  const { t } = useTranslation();
  return (
    <AppMenu
      open={publishVersion.isOpen}
      anchorReference={"anchorPosition"}
      anchorPosition={{
        left: (publishVersion.position?.x ?? 0) + 35,
        top: publishVersion.position?.y ?? 0,
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      onClose={() => closeMenu("publish_version_menu")}
      classes={{ list: styles["publish-version-menu"] }}
    >
      <AppMenuItem
        onClick={() => {
          handleChangePublishVersion("");
          closeMenu("publish_version_menu");
        }}
        className={styles["publish-version-item"]}
      >
        {t("editor.no_publish_option")}
      </AppMenuItem>
      {versions?.map((version) => (
        <AppMenuItem
          key={version.version_id}
          onClick={() => {
            handleChangePublishVersion(version);
            closeMenu("publish_version_menu");
          }}
          className={styles["publish-version-item"]}
        >
          {version.version_name}
        </AppMenuItem>
      ))}
    </AppMenu>
  );
};
